import * as React from 'react';
import { ReactNode } from 'react';
import { Col, Row } from '../row';
import { ButtonToolbar } from '../button-toolbar/ButtonToolbar';
import { WizardHeaderFooterRenderProps } from './WizardForm';

export type WizardFooterProps = {
  renderProps: WizardHeaderFooterRenderProps;
  left?: boolean | ReactNode;
  right?: boolean | ReactNode;
};

export const WizardFooter: React.FC<WizardFooterProps> = ({
  renderProps,
  left,
  right,
}) => {
  let leftContent;
  if (left === false) {
    leftContent = null;
  } else if (left) {
    leftContent = left;
  } else {
    leftContent = (
      <ButtonToolbar>{renderProps.saveAndCloseButton()}</ButtonToolbar>
    );
  }

  let rightContent;
  if (right === false) {
    rightContent = null;
  } else if (right) {
    rightContent = right;
  } else {
    rightContent = (
      <ButtonToolbar>
        {renderProps.prevButton()}
        {renderProps.nextButton()}
        {renderProps.finishButton()}
      </ButtonToolbar>
    );
  }
  return (
    <Row>
      <Col>{leftContent}</Col>
      <Col xs={'auto'}>{rightContent}</Col>
    </Row>
  );
};
